module.exports = __webpack_public_path__ + "img/lincthree.1cade0e8.png";